import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { SharedSearchInputStyles } from "../../../styles";

export const StyledSearchInputContainer = styled.div`
    width: 100%;
    padding: 10px 0;

    .SearchInput-container .SearchInput {
        height: 30px;
        ${SharedSearchInputStyles}
    }
`;

export const StyledTableWrapper = styled.div<{ withBorder?: boolean }>`
    border-top: ${({ withBorder }) => (withBorder ? `1px solid ${colorsPalettes.carbon["50"]}` : "")};
`;

export const StyledSideBySideContainer = styled(Flex)`
    gap: 24px;

    > * {
        flex: 1;
        min-width: 0;
    }
`;
